<template>
  <div>
    <Form ref="form" @submitedData="submitedData" />
  </div>
</template>

<script>
import Form from "./form.vue";
export default {
  props: {},
  components: {
    Form,
  },
  data() {
    return {};
  },
  methods: {
    async submitedData(data) {
      try {
        this.loadingWait();
        let post = await this.$api.post(
          "api/v1/warehouse/incoming/postall",
          data
        );
        if (post.data.status == "validation") {
          this.loadingStop();
          this.notifValidasi(post.data.message, true);

          return;
        }
        this.notifSuksesSimpan();
        this.loadingStop();
        this.$router.push("/warehouse/packinglist");
      } catch (error) {
        this.loadingStop();
        this.notifError("Hubungi Insys");
        console.log(error);
      }
    },
  },
};
</script>
<style>
.tengah {
  text-align: center;
}
</style>
